export function StringToESDate(dateString: string): string {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }
  const date = new Date(dateString)
  return new Intl.DateTimeFormat("es-ES", options).format(date)
}

export function formatDate(date: Date) {
  const months = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ]
  const day = date.getDate()
  const month = months[date.getMonth()]
  const year = date.getFullYear()
  return `${day} de ${month}, ${year}`
}

export function FormatSlugDate(date: Date) {
  const months = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ]

  // Función para rellenar con ceros a la izquierda si el número es menor que 10
  const padWithZero = (number: number) => number.toString().padStart(2, "0")

  const day = padWithZero(date.getDate())
  const month = months[date.getMonth()]
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export function FormatDateCurrentDate(date: Date) {
  const options = { day: "2-digit", month: "long", year: "numeric" } as const
  const formattedDate = date
    .toLocaleDateString("es-ES", options)
    .replace(/ /g, "-")
  return formattedDate.replace(/-de-/g, "-")
}

export function ToISODate(date: Date) {
  return date.toISOString().split("T")[0]
}

export function ParseDate(dateString: string) {
  const [day, month, year] = dateString.split("-")
  const months: any = {
    enero: 0,
    febrero: 1,
    marzo: 2,
    abril: 3,
    mayo: 4,
    junio: 5,
    julio: 6,
    agosto: 7,
    septiembre: 8,
    octubre: 9,
    noviembre: 10,
    diciembre: 11,
  }

  // Crear la fecha en UTC
  return new Date(
    Date.UTC(parseInt(year), months[month.toLowerCase()], parseInt(day))
  )
}
